export const NAV_BY_ROLE = {
  SUPER_ADMIN: [
    { to: '/admin/dashboard', labelKey: 'nav.platformDashboard' },
    { to: '/admin/tenants', labelKey: 'nav.salons' },
    { to: '/admin/staff-registrations', labelKey: 'nav.staffRegistrations' },
    { to: '/admin/users', labelKey: 'nav.users' },
    { to: '/admin/activity-logs', labelKey: 'nav.activityLogs' },
  ],
  SALON_MANAGER: [
    { to: '/salon/dashboard', labelKey: 'nav.salonDashboard' },
    { to: '/salon/settings', labelKey: 'nav.salonProfile' },
    { to: '/salon/branches', labelKey: 'nav.branches' },
    { to: '/salon/services', labelKey: 'nav.services' },
    { to: '/salon/appointments', labelKey: 'nav.appointments' },
    { to: '/salon/staff', labelKey: 'nav.staff' },
    { to: '/salon/staff-performance', labelKey: 'nav.staffPerformance' },
    { to: '/salon/products', labelKey: 'nav.products' },
    { to: '/salon/pos', labelKey: 'nav.pos', newTab: true },
    { to: '/salon/orders', labelKey: 'nav.orders' },
    { to: '/salon/inventory', labelKey: 'nav.inventory' },
    { to: '/salon/campaigns', labelKey: 'nav.campaigns' },
    { to: '/salon/reviews', labelKey: 'nav.reviews' },
    { to: '/salon/analytics', labelKey: 'nav.analytics' },
    { to: '/salon/activity-logs', labelKey: 'nav.activityLogs' },
  ],
  SALON_STAFF: [
    { to: '/staff/dashboard', labelKey: 'nav.myDashboard' },
    { to: '/staff/appointments', labelKey: 'nav.appointments' },
    { to: '/staff/services', labelKey: 'nav.services' },
    { to: '/staff/orders', labelKey: 'nav.orders' },
    { to: '/salon/pos', labelKey: 'nav.pos', newTab: true },
    { to: '/salon/reviews', labelKey: 'nav.reviews' },
    { to: '/staff/clients', labelKey: 'nav.clients' },
  ],
  CLIENT: [
    { to: '/client/dashboard', labelKey: 'nav.myDashboard' },
    { to: '/book', labelKey: 'nav.bookAppointment' },
    { to: '/client/appointments', labelKey: 'nav.myAppointments' },
    { to: '/explore', labelKey: 'nav.exploreSalons' },
    { to: '/client/bookmarks', labelKey: 'nav.savedSalons' },
    { to: '/marketplace', labelKey: 'common.marketplace' },
    { to: '/client/cart', labelKey: 'common.cart' },
    { to: '/client/orders', labelKey: 'nav.myOrders' },
    { to: '/client/history', labelKey: 'nav.history' },
    { to: '/client/reviews', labelKey: 'nav.myReviews' },
  ],
};

export const STAFF_ANALYTICS_LINK = { to: '/staff/analytics', labelKey: 'nav.analytics' };
